<svelte:options tag="header-beta"/>

<script>
    let isDropDown = false;
    let isOpenProfile = false;
    const arrowIcon = isDropDown ? 'iconm-arrow_up arrow up' : 'iconm-arrow_down_2 arrow down';
    const handleDropDown = () => isDropDown = !isDropDown;
    const handleOpenProfile = () => isOpenProfile = !isOpenProfile;
</script>

<nav>
    <div class="nav-container">
        <div class="nav-left">
            <i id="header-rappi-logo" class="iconm-rappi-logo logo"></i>
            <div class="drop">

                <p on:click={handleDropDown}> Restaurante <i class="{arrowIcon}"/></p>

                {#if isDropDown }
                    <ul>
                        <li class="item">
                            <p>Restaurantes</p>
                            <p>Mercados</p>
                            <p>Farmacias</p>
                            <p>Rappi Shopping</p>
                            <p>Bebidas</p>
                            <p>Kiosco</p>
                            <p>Rappi Travel</p>
                            <p>Doná Ahora</p>
                        </li>
                    </ul>
                {/if}

            </div>
        </div>
        <div class="nav-rigth">
            <i class="iconm-user-logged user-logo" on:click={handleOpenProfile}/>
            {#if isOpenProfile }
                <div class="container-profile">
                    <div class="prime-welcome">
                        <div class="details-container">
                            <div class="profile-img-container">
                                <img
                                        class="user-profile-image"
                                        src="https://profile-pics.rappi.com/uploads/application_users/default_profile_pic.jpg"
                                        alt="user-profile-image"/>
                                {#if false}
                                    <img
                                            class="prime-micro"
                                            src="https://images.rappi.com/web/prime_crown-new.png?e=webp"
                                            alt="Logo RappiPrime Crown"/>
                                {/if}
                            </div>
                            <p>Hola!<b> Jose</b></p>
                        </div>
                    </div>
                    <div class="container-items">
                        <div class="rappi-creditos">
                            <p>RappiCreditos disponible</p>
                            <h3>1,000 RappiCréditos</h3>
                        </div>
                        <ul class="list-profile">
                            <li><p>Ajustes de cuenta</p></li>
                            <li><p>Métodos de pago</p></li>
                            <li><p>Ingresar cupón</p></li>
                            <li><p>Centro de ayuda</p></li>
                            <li><p>Cerrar sesión</p></li>
                        </ul>
                    </div>
                </div>
            {/if}
        </div>
    </div>

</nav>

<style type="text/scss">
    @import './styles/header';
    @import './styles/global-styles';
    @import './styles/icons';
    @import './styles/inputs';
    @import './styles/main';

    .container-profile {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        position: absolute;
        top: 65px;
        z-index: 12;
        opacity: 1;
        border: 1px solid #f1f1f1;
        visibility: visible;
        right: 15px;
        min-width: 250px;
        border-radius: 8px;
        background: #FFFFFF;

        .container-items {
            width: 100%;

            .rappi-creditos {
                padding: 0 10px;

                p {
                    font-size: 12px;
                    color: #FF441F;
                }

                h3 {
                    font-family: "Poppins-SemiBold", Helvetica, Arial, sans-serif;
                    font-size: 16px;
                }
            }

            .list-profile {
                padding: 0;

                li {
                    cursor: pointer;
                    list-style: none;
                    transition: all 0.3s linear;
                    color: #7d7d7d;
                    font-size: 14px;
                    font-family: "Poppins-Regular", Helvetica, Arial, sans-serif;
                    padding: 2px 10px;

                    &:hover {
                        background-color: rgba(255, 68, 31, 0.04);
                        color: #FF441F;
                    }

                }
            }

        }

        .prime-welcome {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-direction: row;
            position: relative;
            width: 100%;


            .details-container {
                width: 100%;
                display: flex;
                padding: 6px 21px;

                .profile-img-container {
                    padding: 11px 3px;
                    margin: 0;

                    img {
                        width: 40px;
                        /* height: 40px; */
                        background-color: #FAFAF8;
                        border-radius: 18px;
                    }
                }

                p {
                    font-size: 16px;
                    padding: 8px;
                }
            }
        }
    }

    nav {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        height: 20px;
        background-color: #ffffff;
        z-index: 10;

        .nav-container {
            width: 100%;
            background-color: #FFFFFF;
            border-bottom: 1px solid #e5edef;
            padding: 11px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: row;

            .drop {
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                flex-direction: row;
                width: 220px;
                height: 48px;
                margin: 0 16px 0 24px;
                cursor: pointer;
                position: relative;

                .item {
                    margin: 0;
                    max-height: 200px;
                    border-top: 1px solid #f9f9f8;

                    p {
                        font-family: "Poppins-Regular", Helvetica, Arial, sans-serif;
                        color: #706967;
                        font-size: 14px;
                        padding: 18px 16px;
                        margin: 0;
                    }


                }
            }

            .nav-left {
                display: flex;
                align-items: center;
                flex-direction: row;
                width: 100%;
                height: 48px;
                margin: 0 16px 0 24px;
                cursor: pointer;
                position: relative;
                justify-content: flex-start;

                p {
                    font-family: "Poppins-SemiBold", Helvetica, Arial, sans-serif;
                    font-size: 16px;
                    color: #FF441F;
                }

                ul {
                    position: absolute;
                    width: 220px;
                    font-size: 14px;
                    border-radius: 15px;
                    top: 40px;
                    background-color: #FFFFFF;
                    overflow: hidden;
                    overflow-y: scroll;
                    height: 235px;
                    list-style-type: none;
                    margin: 0;
                    padding: 0;

                }

            }

            .nav-rigth {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                flex-direction: row;
                margin-right: 15px;

                i {
                    font-size: 28px;
                }
            }

            .iconm-rappi-logo {
                margin-left: 16px;
                font-size: 32px;
                cursor: pointer;
            }
        }

    }


</style>

